import { render, staticRenderFns } from "./EditPickupLocation.vue?vue&type=template&id=55c6250e&scoped=true"
import script from "./EditPickupLocation.vue?vue&type=script&lang=js"
export * from "./EditPickupLocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c6250e",
  null
  
)

export default component.exports